'use client'

import React from 'react'

export const ArtistTalk = () => {
  return (
    <div className="p-[10px] flex gap-[8px] items-center w-[360px] ml-[20px] mr-[20px] h-[40px] rounded-lg border border-white/20 bg-white/20 shadow-[0_0_3px_0_rgba(0,0,0,0.25)] backdrop-blur-[17px]">
      <img src="/img/tag/loopy/artisttalk.svg" />
      <p className="text-gray-8 text-[12px] font-semibold leading-[18px]">
        {'우리 엄마가 가벼운 사람 되지 말라고 그랬어~'}
      </p>
    </div>
  )
}
